
import { useSelector as UseSelector } from 'react-redux';
import { Layout as BaseLayout, LayoutProps, Sidebar, useSetLocale } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
import { darkTheme, lightTheme } from './themes';
import { AppState } from '../types';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';

const CustomSidebar = (props: any) => <Sidebar {...props} size={200} />;

const useStyles = makeStyles({
    '@global': {
        '.filter-field .MuiInputBase-root': {
            fontSize: '0.75rem'
        },
    },
});

const Layout = (props: LayoutProps) => {
    useStyles()
    const setLocale = useSetLocale();

    const theme = UseSelector((state: AppState) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );

    //TODO: change to sagas or other place, maybe not in layout
    useEffect(() => {
        console.log('effect')
        const locale = localStorage.getItem('locale')

        // setTimeout(() => {
        console.log(locale)
        if (locale)
            setLocale(locale)
        // }, 5000)
    }, [setLocale])

    return (
        <BaseLayout
            {...props}
            appBar={AppBar}
            sidebar={CustomSidebar}
            menu={Menu}
            theme={theme as any}
        />
    );
};

export default Layout